import { Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from "@heroui/react";
import { Check } from "@phosphor-icons/react";
import { AlertCircle } from "assets/icons";
import ButtonNew from "components/buttonNew/buttonNew";
import { toast } from "react-toastify";

export interface DeleteLabelModalProps {
  isOpen: boolean;
  onClose?: () => void;
  labelName: string;
  labelId: any;
  handleDelete: (id: any) => Promise<void>;
}

export const DeleteLabelModal = ({ isOpen, onClose, labelName, labelId, handleDelete }: DeleteLabelModalProps) => {
  const handleConfirmDelete = async () => {
    try {
      await handleDelete(labelId); // Call the passed delete function
      toast.success(`${labelName} verwijderd`);
    } catch (error) {
      toast.error(`Error bij het verwijderen van ${labelName}`);
    } finally {
      onClose && onClose(); // Close the modal
    }
  };

  return (
    <Modal onClose={onClose} isOpen={isOpen} isDismissable={true} size="4xl" scrollBehavior="inside">
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">
              <p className="flex items-center gap-1 text-sm font-medium text-status-bad">
                <AlertCircle className="h-[17px] w-[17px]" /> Bevestig verwijderen
              </p>
            </ModalHeader>
            <ModalBody>
              <p>Weet je zeker dat je het label "<strong>{labelName}</strong>" wilt verwijderen?</p>
            </ModalBody>
            <ModalFooter className="justify-start">
              <ButtonNew
                variant="primaryBrick"
                onClick={handleConfirmDelete}
                icon={<Check />}
                label="Verwijderen"
              />
              <ButtonNew
                variant="secondaryNeutral"
                onClick={onClose}
                label="Annuleren"
              />
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
